import { DataTypeColumn } from '../../components/DataExpansionComponents/Common/commonColumnHelpers'
import { AttributionCode } from './tradespend_api'

type CustomFields = 'url'

export const ATTRIBUTION_CODES_COLUMNS: Record<
  keyof AttributionCode | CustomFields,
  DataTypeColumn
> = {
  name: {
    header: 'Name',
    group: 'Code Information',
  },
  description: {
    header: 'Description',
    group: 'Code Information',
  },
  code: {
    header: 'Code',
    group: 'Code Information',
  },
  url: {
    header: 'Shareable URL',
    group: 'Code Information',
    tooltipName: 'attribution_code_url',
  },
  id: {
    header: 'ID',
    group: 'Code Information',
  },
  color: {
    header: 'Color',
    group: 'Code Information',
  },
  is_default: {
    header: 'Default',
    group: 'Code Information',
  },
  view_count: {
    header: 'Views',
    group: 'Usage Information',
    tooltipName: 'view_count',
  },
  emails_captured: {
    header: 'Emails Captured',
    group: 'Usage Information',
    tooltipName: 'emails_captured',
  },
  click_count: {
    header: 'Clicks',
    group: 'Usage Information',
    tooltipName: 'click_count',
  },
  ctr: {
    header: 'CTR (%)',
    group: 'Usage Information',
    tooltipName: 'ctr',
  },
  total_enrollments: {
    header: 'Enrollments',
    group: 'Usage Information',
    tooltipName: 'total_enrollments',
  },
  total_claims: {
    header: 'Total Claims',
    group: 'Usage Information',
    tooltipName: 'total_claims',
  },
  pending_claims: {
    header: 'Pending Claims',
    group: 'Usage Information',
    tooltipName: 'pending_claims',
  },
  invalid_claims: {
    header: 'Invalid Claims',
    group: 'Usage Information',
    tooltipName: 'invalid_claims',
  },
  paid_claims: {
    header: 'Paid Claims',
    group: 'Usage Information',
    tooltipName: 'paid_claims',
  },
  unpaid_valid_claims: {
    header: 'Unpaid Valid Claims',
    group: 'Usage Information',
    tooltipName: 'unpaid_valid_claims',
  },
  total_validated_units: {
    header: 'Validated Units',
    group: 'Usage Information',
    tooltipName: 'total_validated_units',
  },
  total_validated_payout: {
    header: 'Validated Payout',
    group: 'Usage Information',
    tooltipName: 'total_validated_payout',
  },
  created_by: {
    header: 'Created By',
    group: 'Metadata',
  },
  assigned_by: {
    header: 'Assigned By',
    group: 'Metadata',
  },
  created: {
    header: 'Created Date',
    group: 'Metadata',
  },
  modified: {
    header: 'Last Modified',
    group: 'Metadata',
  },
  offer: {
    header: 'Offer',
    group: 'Code Information',
  },
  offer_code: {
    header: 'Offer Code',
    group: 'Code Information',
  },
}
